import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import { Grid } from "@mui/material";
import React from "react";

const SuperAdminStatsSkeleton = () => {
	return (
        <Grid container spacing={5}>
            <Grid size={12}>
				<Box sx={{ display: "flex", alignItems: "center", gap: "30px" }}>
					<Skeleton variant="rectangular" width={234.4} height={39.5} />
					<Skeleton variant="rectangular" width={272} height={36.7} />
					<Skeleton variant="rectangular" width={70} height={35.8} />
				</Box>
			</Grid>
            <Grid size={12}>
				<Skeleton variant="rectangular" height={242.83} />
			</Grid>
            <Grid size={6}>
				<Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
					<StatBoxSkeleton />
					<StatBoxSkeleton />
					<StatBoxSkeleton />
					<StatBoxSkeleton />
					<StatBoxSkeleton />
					<StatBoxSkeleton />
					<StatBoxSkeleton />
					<StatBoxSkeleton />
					<StatBoxSkeleton />
				</Box>
			</Grid>
            <Grid size={6}>
				<Skeleton variant="rectangular" height={438.35} />
			</Grid>
        </Grid>
    );
};

export default SuperAdminStatsSkeleton;

const StatBoxSkeleton = () => {
	return (
		<Skeleton
			variant="rectangular"
			sx={{
				flex: { xs: "0 1 20%", xl: "0 1 20%" },
				minWidth: "236px",
				maxWidth: "380px",
			}}
			height={132}
		/>
	);
};
